import request from './request'

export function listSourceCostReport(data) {
  return request.post('/mes/source-cost-reports/list', data)
}
